import { Dispatch, SetStateAction, useState } from "react";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { IEditarPerguntasERespostasForm } from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";
import CadastrarPerguntasERespostas from "../PerguntasERespostasForm/CadastrarPerguntasERespostas";
import ListarPerguntasERespostas from "../PerguntasERespostasForm/ListarPerguntasERespostas";

interface IFormularioModalProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    idFormulario: number;
}

export default function FormularioModal(props: IFormularioModalProps) {
    const [cadastrandoOuEditando, setCadastrandoOuEditando] = useState(true);
    const [perguntaSendoEditada, setPerguntaSendoEditada] = useState<
        IEditarPerguntasERespostasForm | undefined
    >(undefined);

    return (
        <div>
            {cadastrandoOuEditando ? (
                <ListarPerguntasERespostas
                    setPerguntaSendoEditada={setPerguntaSendoEditada}
                    setMostrarPerguntasERespostas={setCadastrandoOuEditando}
                    idFormulario={props.idFormulario}
                />
            ) : (
                <CadastrarPerguntasERespostas
                    setPerguntaSendoEditada={setPerguntaSendoEditada}
                    perguntaERespostas={perguntaSendoEditada}
                    idFormulario={props.idFormulario}
                    setMostrarPerguntasERespostas={setCadastrandoOuEditando}
                />
            )}
        </div>
    );
}
